import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import safeGet from 'lodash.get';
import { useMemo } from 'react';

const ContentImage = ({
    src,
    ...props
}: {
    src: string;
    alt: string;
    loading?: 'eager' | 'lazy' | undefined;
    className?: string | undefined;
}) => {
    const parseFilename = /.*\/(.*)(\..+)$/;
    const matchFilename = src.match(parseFilename);
    const cleanFilename = (matchFilename && matchFilename[1]) ? matchFilename[1] : src
    const data: {
        allFile: {
            nodes: Array<{
                base: string;
                url: string;
                loading?: 'eager' | 'lazy' | undefined;
                className?: string | undefined;
            }>;
        };
    } = useStaticQuery(graphql`
        {
            allFile(
                filter: {
                    internal: { mediaType: { regex: "/image/" } }
                    sourceInstanceName: { eq: "__PROGRAMMATIC__" }
                }
            ) {
                nodes {
                    base
                    childImageSharp {
                        gatsbyImageData(breakpoints: [640, 1200], width: 685, placeholder: NONE, formats: WEBP)
                    }
                    publicURL
                }
            }
        }
    `);

    const match = useMemo(
        () => data?.allFile.nodes.find(({ base }) => base.includes(cleanFilename)),
        [data, cleanFilename]
    );

    const gatsbyImage = safeGet(match, 'childImageSharp.gatsbyImageData') as
        | IGatsbyImageData
        | undefined;

    return gatsbyImage ? <GatsbyImage image={gatsbyImage} {...props} /> : null;
};

export default ContentImage;
